export default "__VITE_ASSET__BWRE1d6n__"